module.exports = __webpack_public_path__ + "img/streaming-tv-app.ba2a9e45.png";